import { BaseModal, Button } from '@cokitchen/cokitchen-components';
import React, { useState } from 'react';
import { Calendar } from 'react-date-range';
import './styles.scss';

const DatePicker = ({
  isOpen,
  onClose,
  title,
  handleDateSelect,
  minDate
}: {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  handleDateSelect: (value: Date | undefined) => void;
  minDate?: Date;
}) => {
  const [date, setDate] = useState<Date>();
  return (
    <BaseModal isOpen={isOpen} onRequestClose={onClose} title={title || 'Select Date'}>
      <div className='daterange'>
        <Calendar
          date={date}
          minDate={minDate}
          onChange={(item) => {
            setDate(item as Date);
          }}
          className='calendar'
        />
      </div>
      <div className='flex gap-3 justify-end'>
        <Button
          variant='block'
          color='gray'
          className='w-[90px] h-[42px] text-sm'
          onClick={onClose}>
          Cancel
        </Button>
        <Button
          variant='block'
          color='primary'
          className='w-[90px] h-[42px] text-sm'
          onClick={() => {
            handleDateSelect(date);
            onClose();
          }}>
          Done
        </Button>
      </div>
    </BaseModal>
  );
};

export default DatePicker;
